import { utilities } from './utilities';
import { plugins } from './plugins';
import { multiCarousel } from './multiCarousel';
import { navigation as navi } from './navigation';
import { forms } from './forms';
import { lightboxConfig } from './lightbox-config';
import { events as eventHandler } from './events';
import { Collapse } from "bootstrap";

import 'bootstrap';
import './accordions';
import './collapse';
import './share-popover';
import 'jquery-touchswipe';

const EventsResponsive = () => {
    const returnObj = {
        currentSize: null
    };

    /**
     * All js-scripts here is to fixing or moving elements
     * to reduce traffic and overloads
     *
     * All funktion started only on xs-size
     */
    returnObj.cloneChangePos = function (findEl, cloneEl, pasteEl) {
        if (jQuery(document).find(findEl).length === 0) {
            jQuery(pasteEl).append(jQuery(cloneEl).clone().addClass(findEl.replace(new RegExp('\.|#'), '')).removeClass(cloneEl.replace(new RegExp('\.|#'), '')));
        }
    };
    returnObj.moveChangePos = function (source, target) {
        jQuery(target).append(jQuery(source));
    };

    /** all Functions */
    /**
     * change DOM-Position
     */
    returnObj.changePos = function () {
        // Mainnavigation L1
        returnObj.cloneChangePos('.xs-mainnav', '.mainnav', '.js-rf-mainnav');
        jQuery('.xs-mainnav').removeClass('navbar-collapse d-none d-md-flex').addClass('collapse navbar-collapse');
        jQuery('.mainnav .nav-xs-special').remove();
        jQuery('.xs-mainnav > div:has(.loggedin-txt), .xs-mainnav > div.basket-flyout-popover-content, .xs-mainnav > div.basket-flyout-button').remove();

        // Headernavigation L2
        if (jQuery(document).find('.js-headernav').length === 0) {
            jQuery('.home .js-rf-mainnav').append(jQuery('.headernav > div').eq(0).children('.float-start').eq(0).clone()
                .removeClass('float-start head-button-eshop btn-l').addClass('btn-xl head-button-eshop-xs'));
            jQuery('.home .js-rf-mainnav').append('<nav class="xs-mainnav-lvl2"><ul class="nav navbar-nav js-headernav"></ul>');

            jQuery('.home .headernav > div').eq(0).children('.float-start').eq(1).children().find('a').each(function (i, el) {
                jQuery(el).children('.glyphicons-chevron-right').addClass('float-end');
                jQuery('.home .js-headernav').append('<li>' + jQuery(el).parent().html() + '</li>');
            });
        }
    };

    returnObj.mediaResize = function ($selector) {
        if (!$selector) {
            $selector = jQuery(document);
        } else if (!($selector instanceof $)) {
            $selector = jQuery($selector);
        }
        //init carousel multi item
        multiCarousel.init($selector);

        if (jQuery(window).width() <= utilities.jsScreenSMmax) {
            $selector.find('.scroll-box').setuScrollDestroy();
        }

        forms.clearInputButton($selector);
        lightboxConfig.initMask('video', $selector);

        $selector.find('.teaser-info').find('img').parent().parent().each(function () {
            var bodyW = jQuery(this).width();
            jQuery(this).find('img').each(function (i, img) {
                img.style.width = 'auto';

                if (bodyW <= jQuery(img).width()) {
                    img.style.width = '100%';
                }
            });
        });
    };

    /**
     * Resizing main functions
     */

    returnObj.smEnable = function () {
        returnObj.moveChangePos('#setu-products-last-seen', '#setu-products-last-seen-sm');
    };

    returnObj.smDisable = function () {
        returnObj.moveChangePos('#setu-products-last-seen', '#setu-products-last-seen-default');
    };

    returnObj.handleSearchButtonClick = function (event) {
        var searchButton = document.getElementById("setu-search-react-search-component-trigger");
        if (searchButton) {
            searchButton.dispatchEvent(new Event('click', { bubbles: true }));
        }
        return false
    }

    returnObj.xsEnable = function () {
        returnObj.changePos();
        // Search
        returnObj.moveChangePos('.js-move-search > form', '.js-rf-search');

        var button = document.getElementById("setu-search-react-search-component-trigger-mobile");
        button.addEventListener("click", returnObj.handleSearchButtonClick);

        navi.xsBreadcrumb();
        jQuery('.scroll-box').setuScrollDestroy();

        // @TODO remove datepicker anyway why do this???
        // plugins.removeDatepicker();

        jQuery('.carousel').parent('.at-heighest-col').removeAttr('style');

        returnObj.moveChangePos('.js-xs-clone-tab > div', '.js-xs-clone-tab-target');
        jQuery('.product-carousel').addClass('carousel-inner mobile');
        jQuery('.carousel .carousel-item').removeAttr('style');
        jQuery('.carousel .carousel-item .teaser').removeAttr('style');

        // product carousel: only one picture must be active
        jQuery('.product-carousel').each(function (j, o) {
            const items = jQuery('.carousel-item', o);
            if (items.length < 5) {
                items.each(function (i, el) {
                    if (i === 0) {
                        jQuery(el).addClass('active');
                    } else {
                        jQuery(el).removeClass('active');
                    }
                });
            }
        });

        // fix logout on xs-size
        jQuery('button[data-bs-target="#headernavLogout"]').click(function () {
            var href = jQuery('a[data-bs-target="#headernavLogout"]').attr('href');
            window.location = href;
        });

        // js-nav-mobile added Classes
        jQuery('.js-nav-mobile').addClass('nav nav-mobile');
    };

    returnObj.xsDisable = function () {
        var button = document.getElementById("setu-search-react-search-component-trigger-mobile");
        button.removeEventListener("click", returnObj.handleSearchButtonClick);

        jQuery('.scroll-box').setuScroll();

        // js-nav-mobile remove Classes
        jQuery('.js-nav-mobile').removeClass('nav nav-mobile');

        returnObj.moveChangePos('.js-xs-clone-tab-target > div', '.js-xs-clone-tab');
        jQuery('.product-carousel .carousel-inner.mobile').removeClass('mobile')

        jQuery('.product-carousel').each(function (j, o) {
            if (jQuery('.product-carousel .carousel-item', o).length < 5) {
                jQuery('.product-carousel .carousel-item', o).each(function (i, el) {
                    jQuery(el).addClass('active');
                });
            }
        });

        $(".econda-opacity, .econda").removeClass('touch-effect');

    };

    returnObj.init = function () {
        if (jQuery(window).width() <= utilities.jsScreenSMmax) {
            returnObj.smEnable();
            returnObj.currentSize = 'sm';

            if (jQuery(window).width() < utilities.jsScreenSMmin) {
                returnObj.xsEnable();
                returnObj.currentSize = 'xs';
            }
        } else {
            jQuery('.product-carousel').each(function (j, o) {
                const items = jQuery('.product-carousel .carousel-item', o);
                if (items.length < 5) {
                    items.each(function (i, el) {
                        jQuery(el).addClass('active');
                    });
                }
            });
        }

        eventHandler.addListener('mediaResize', returnObj.mediaResize, returnObj);
        eventHandler.addListener('xsEnable', returnObj.xsEnable, returnObj);
        eventHandler.addListener('xsDisable', returnObj.xsDisable, returnObj);
        eventHandler.addListener('smEnable', returnObj.smEnable, returnObj);
        eventHandler.addListener('smDisable', returnObj.smDisable, returnObj);

        returnObj.mediaResize();

        jQuery(window).smartresize(function () {
            var newSize, oldSize = returnObj.currentSize;

            if (jQuery(window).width() >= utilities.jsScreenSMmin) {
                if (jQuery(window).width() > utilities.jsScreenSMmax) {
                    newSize = 'l';
                } else {
                    newSize = 'sm';
                }
            } else {
                newSize = 'xs';
            }

            if (newSize != oldSize) {
                if (newSize == 'l') {
                    eventHandler.fireDataEvent('xsDisable');
                    eventHandler.fireDataEvent('smDisable');
                } else {
                    if (newSize == 'xs') {
                        eventHandler.fireDataEvent('xsEnable');
                    }

                    if (oldSize == 'xs') {
                        eventHandler.fireDataEvent('xsDisable');
                    }

                    if (newSize == 'sm') {
                        eventHandler.fireDataEvent('smEnable');
                    }

                    if (oldSize == 'sm') {
                        eventHandler.fireDataEvent('smDisable');
                    }
                }
                returnObj.currentSize = newSize;
                eventHandler.fireDataEvent('resize', [oldSize, newSize]);
            }

            eventHandler.fireDataEvent('mediaResize');
        });
    };

    return returnObj;
}
export const eventsResponsive = EventsResponsive();
